export const pimDashboardMeta = {
	name: "Pim",
	key: "pim",
	path: "pim",
};
